import config from 'modules/common/helpers/configHelper';
import httpHelper from 'modules/common/helpers/httpHelper';

const BASE_URL = config.beUrl;

function getKeyHolders() {
  return httpHelper.get(`${BASE_URL}/api/key-holders`, {});
}

function createKeyHolder(keyHolderData: KeyHolder, withoutError: boolean) {
  return httpHelper.post(
    `${BASE_URL}/api/key-holder`,
    { ...keyHolderData },
    undefined,
    withoutError
  );
}

function editKeyHolder(keyHolderData: KeyHolder, withoutError: boolean) {
  return httpHelper.put(
    `${BASE_URL}/api/key-holder`,
    { ...keyHolderData },
    undefined,
    withoutError
  );
}

function deleteKeyHolder(id: string) {
  return httpHelper.delete(`${BASE_URL}/api/key-holder`, { id });
}

export default {
  getKeyHolders,
  createKeyHolder,
  editKeyHolder,
  deleteKeyHolder,
};
